export const getFormState = formName => {
  return state => {
    return state.forms[formName] || { errors: {} };
  };
};
